export default "__VITE_ASSET__BjyuU1yX__"